import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=8d092bb4&"
import script from "./Method.vue?vue&type=script&lang=js&"
export * from "./Method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports